import {
    SET_VEHICLES_LIST,
    UPDATE_VEHICLES_LIST,
    RESET_VEHICLES_LIST,
    BLOCK_VEHICLES_LIST,
} from './types';

export const setVehiclesList = payload => ({
    type: SET_VEHICLES_LIST,
    payload,
});

export const updateVehiclesList = payload => ({
    type: UPDATE_VEHICLES_LIST,
    payload,
});

export const blockVehiclesFromList = payload => ({
    type: BLOCK_VEHICLES_LIST,
    payload,
});

export const resetVehiclesList = () => ({ type: RESET_VEHICLES_LIST });
